// extracted by mini-css-extract-plugin
module.exports = {"timerBox":"GameTimer_timerBox__2vubZ"};